import { useContext } from "react";
import { DefaultContext } from "../../../contexts/default";
import { CardBody } from "../../bootstrap/Card";
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../../bootstrap/Modal";
import FormGroup from "../../bootstrap/forms/FormGroup";
import Input from "../../bootstrap/forms/Input";
import { convertGramaToKg, getFloatCMV } from "../../../utils/cmv/convertQtd";



const ModalHistoricoInsumo = ({ open, handleOpen, rowSelected }) => {
    return (
        <Modal
            isOpen={open}
            setIsOpen={handleOpen}
            isStaticBackdrop
            isScrollable={false}
            isCentered
            size="lg"
            isAnimation
            onSubmit={() => { }}
        >
            <ModalHeader className="p-4 mt-2 justify-content-start" setIsOpen={handleOpen}>
                <ModalTitle>{"Saída de insumos"}</ModalTitle>
            </ModalHeader>
            <ModalBody className="p-0">
                <CardBody>
                    <div className="row g-3 justify-content-center">
                        {rowSelected?.insumes?.map((row) => {
                            return (
                                <>
                                    <FormGroup id="name" label="Insumo" className='col-md-3'>
                                        <Input
                                            disabled={true}
                                            value={row.name}
                                        />
                                    </FormGroup>

                                    <FormGroup id="unit" label="Unidade" className='col-md-2'>
                                        <Input
                                            disabled={true}
                                            value={(row.unit)}
                                        />
                                    </FormGroup>

                                    <FormGroup id="qtd" label="Saida Man." className='col-md-2' >
                                        <Input
                                            disabled={true}
                                            value={getFloatCMV(row.qtd)}
                                        />
                                    </FormGroup>

                                    <FormGroup id="qtdLoss" label="Perda" className='col-md-2'>
                                        <Input
                                            disabled={true}
                                            value={getFloatCMV(row.qtdLoss)}
                                        />
                                    </FormGroup>

                                    <FormGroup id="qtdPromotial" label="Cortesia" className='col-md-2'>
                                        <Input
                                            disabled={true}
                                            value={getFloatCMV(row.qtdPromotial)}
                                        />
                                    </FormGroup>
                                </>
                            )
                        })}
                    </div>

                </CardBody>

            </ModalBody>
        </Modal >
    );
};

export default ModalHistoricoInsumo;
